export const ALLOWED_IMAGE_TYPES = 'image/png, image/jpg, image/jpeg, image/webp, .png, .jpg, .jpeg, .webp'
export const ALLOWED_VIDEO_TYPES = 'video/mp4, video/webm, video/ogg, video/mov, .mp4, video/quicktime, .webm, .ogg, .mov'
export const TRANSLATION_KEY_NOT_PROVIDED = 'TRANSLATION_KEY_NOT_PROVIDED'
export const INVALID_TRANSLATION_KEY = 'INVALID_TRANSLATION_KEY'

export const ENDPOINTS = {
    AUTH: 'user/auth',
    USER_UPDATE: 'user/update',

    CREATE_COMPONENT: 'component/create',
    CREATE_CATEGORY: 'category/create',
    CREATE_TAG: 'tag/create',

    UPDATE_CATEGORY: 'category/update',
    UPDATE_TAG: 'tag/update',
    UPDATE_COMPONENT: 'component/update',

    LIST_CATEGORIES: 'category/list',
    LIST_COMPONENTS: 'component/list-admin',
    LIST_TAGS: 'tag/list',

    DELETE_CATEGORY: 'category/delete',
    DELETE_TAG: 'tag/delete',
    DELETE_COMPONENT: 'component/delete',
    INIT_COPY: 'component/copy'
}

export const COMPONENT_DEFAULT_FORM = {
    _id: '',
    Name: '',
    Category: '',
    Tags: [],
    Link: '',
    Image: '',
    Video: '',
    Price: '',
    Clipboard: ''
}

export const COMPONENT_DEFAULT_ERRORS = {
    Name: false,
    Category: false,
    Tags: false,
    Link: false,
    Image: false,
    Clipboard: false,
    Video: false,
    Price: false
}

export const TAG_DEFAULT_FORM = {
    _id: '',
    Name: ''
}

export const TAG_DEFAULT_ERRORS = {
    Name: false
}

export const CATEGORY_DEFAULT_FORM = {
    _id: '',
    Name: ''
}

export const CATEGORY_DEFAULT_ERRORS = {
    Name: false
}

export const COMPONENT_DEFUALT_FILTERS = {
    Price: 'mix',
    Tag: '',
    Category: '',
    Term: ''
}

export const USER_ROLES = {
    ADMIN: 'admin',
    USER: 'user'
}

export const ClipboardBase = {
    'type': '@webflow/XscpData',
    'payload': {
        'nodes': [],
        'styles': [],
        'assets': [],
        'ix1': [],
        'ix2': { 'interactions': [], 'events': [], 'actionLists': [] }
    },
    'meta': {
        'unlinkedSymbolCount': 0,
        'droppedLinks': 0,
        'dynBindRemovedCount': 0,
        'dynListBindRemovedCount': 0,
        'paginationRemovedCount': 0,
        'universalBindingsRemovedCount': 0
    }
}
